import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RecentChange, Status } from '@core/data';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { OpenRecentChanges } from '../sample-index/sample-index.state-actions';
import { StorageRegimeState } from '../storage-regime-index/storage-regime.state';

export interface RecentChangesDialogData {
    orgKey: string;
}

@Component({
    selector: 'pv-recent-changes-dialog',
    templateUrl: 'recent-changes.dialog.html',
    styles: [`
    .recent-changes-content { max-height: 60vh; min-width: 640px; overflow-y: auto; }
    .recent-changes-intro { margin: 0 0 16px; color: #545454; }
    .recent-changes-state { display: flex; align-items: center; gap: 12px; padding: 16px 0; }
    .recent-changes-table { width: 100%; border-collapse: collapse; }
    .recent-changes-table th { text-align: left; font-weight: 600; padding: 8px 12px; border-bottom: 2px solid #e0e0e0; position: sticky; top: 0; background: #fff; }
    .recent-changes-table td { padding: 10px 12px; border-bottom: 1px solid #eeeeee; vertical-align: top; }
    .recent-changes-type { font-size: 12px; color: #757575; text-transform: uppercase; letter-spacing: 0.04em; }
    .recent-changes-muted { color: #757575; font-size: 13px; }
    .recent-changes-actions { justify-content: flex-end; }
    .recent-changes-warning-block { border: 2px solid #c0392b; background-color: #fdecea; padding: 8px 10px; border-radius: 2px; }
    .recent-changes-warning-label { font-weight: bold; color: #c0392b; text-transform: uppercase; font-size: 11px; margin-bottom: 2px; }
    `],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecentChangesDialog {

    @Select(StorageRegimeState.recentChanges)
    rows$: Observable<RecentChange[]>;

    @Select(StorageRegimeState.recentChangesStatus)
    status$: Observable<Status>;

    readonly Status = Status;

    constructor(
        private _dialog: MatDialogRef<RecentChangesDialog>,
        private _store: Store,
        @Inject(MAT_DIALOG_DATA) private _data: RecentChangesDialogData,
    ) { }

    retry() {
        this._store.dispatch(new OpenRecentChanges(this._data.orgKey));
    }

    close() {
        this._dialog.close();
    }
}
